import { Image } from 'components/modulab/Image';
import { Prose } from 'components/modulab/Prose';
import Head from 'next/head';
import { JSX } from 'react';
import { localeSpecificGroup } from 'utils/override';

type ErrorProps = {
  locale: string;
  statusCode?: number | string;
};

export function Error({ locale, statusCode = 500 }: ErrorProps): JSX.Element {
  const staticValues = CONTENT.get(locale);

  return (
    <>
      <Head>
        <title>{staticValues.pageTitle}</title>
      </Head>
      <div className="bg-gray-1 py-10">
        <div className="mx-auto max-w-4/5">
          <div className="type-display-lg">{staticValues.heading}</div>
          <h2 className="type-display-md">{staticValues.subHeading}</h2>
          <Prose dangerouslySetInnerHTML={{ __html: staticValues.firstLine }} />
          {staticValues.secondLine && (
            <Prose
              dangerouslySetInnerHTML={{
                __html: staticValues.secondLine,
              }}
            />
          )}
          <p>
            {staticValues.errorCode}: {statusCode}
          </p>
        </div>
        <div>
          <Image
            layout="responsive"
            alt="Error Cat"
            src="https://mhgprod-cdn-efeke3f5guabc4dh.z02.azurefd.net/singsaver/strapi-uploads/Desktop_Error_Cat_4236529699.png"
            width={1712}
            height={440}
          />
        </div>
      </div>
    </>
  );
}

export function ErrorWithoutTlw({
  locale,
  statusCode = 500,
}: ErrorProps): JSX.Element {
  const staticValues = CONTENT.get(locale);

  return (
    <>
      <Head>
        <title>{staticValues.pageTitle}</title>
      </Head>
      <div
        style={{
          paddingTop: '40px',
          paddingBottom: '40px',
        }}
      >
        <div
          style={{
            maxWidth: '80%',
            margin: '0 auto',
          }}
        >
          <div
            style={{
              fontSize: '2.25rem',
              lineHeight: '2.5rem',
              fontWeight: 700,
              marginBottom: '1rem',
            }}
          >
            {staticValues.heading}
          </div>
          <h2
            style={{
              fontSize: '1.5rem',
              lineHeight: '2rem',
              fontWeight: 600,
              marginBottom: '1rem',
            }}
          >
            {staticValues.subHeading}
          </h2>
          <Prose dangerouslySetInnerHTML={{ __html: staticValues.firstLine }} />
          {staticValues.secondLine && (
            <Prose
              dangerouslySetInnerHTML={{
                __html: staticValues.secondLine,
              }}
            />
          )}
          <p
            style={{
              marginTop: '1rem',
              fontSize: '1rem',
              lineHeight: '1.5rem',
            }}
          >
            {staticValues.errorCode}: {statusCode}
          </p>
        </div>

        <Image
          layout="responsive"
          alt="Error Cat"
          src="https://mhgprod-cdn-efeke3f5guabc4dh.z02.azurefd.net/singsaver/strapi-uploads/Desktop_Error_Cat_4236529699.png"
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          width={'100%' as any}
          height={440}
        />
      </div>
    </>
  );
}

export const CONTENT = localeSpecificGroup({
  heading: {
    en: 'Oops!',
    zh: '抱歉',
  },
  subHeading: {
    en: 'Sorry, something went wrong.',
    zh: '你所瀏覽的網頁出現錯誤。',
  },
  firstLine: {
    en: "Please try again later, here's a link back to our <a href='/'>homepage</a>.",
    'en-hk':
      "Please try again later, here's a link back to our <a href='/en'>homepage</a>.",
    'zh-hk': '請稍後再次瀏覽網頁，或前往<a href="/zh">MoneyHero首頁</a>。',
    'zh-tw': '請稍後再次瀏覽網頁，或前往<a href="/">Money101.com.tw首頁</a>。',
  },
  secondLine: {
    _: undefined,
    'en-hk':
      'If you need any further assistance, please contact our <a href="https://support.moneyhero.com.hk/hc/en-us">help desk</a>.',
    'en-sg':
      'If you need any further assistance, please contact our <a href="https://singsaver.zendesk.com/hc/en-us/categories/360000589012">help desk</a>.',
    'zh-hk':
      '如果你需要更多資訊，我們的<a href="https://support.moneyhero.com.hk/hc/zh-tw">網上支援</a>能為你提供協助。',
    'zh-tw':
      '如果你需要更多資訊，我們的<a href="https://www.money101.com.tw/%E5%B8%B8%E8%A6%8B%E5%95%8F%E9%A1%8C">網上支援</a>能為你提供協助。',
  },
  errorCode: {
    en: 'Error code',
    zh: '錯誤編號',
  },
  pageTitle: {
    'en-ph': 'Page not found | Moneymax',
    'en-sg': 'SingSaver - Personal Finance Comparison Site',
    'en-hk': 'MoneyHero | Page not found',
    'zh-hk': 'MoneyHero | 比較番，揀到啱！ ',
    'zh-tw': '輕鬆比較信用卡、信用貸款、定存及更多金融產品 | Money101.com.tw',
  },
});
